import { IAppState } from "../../../app/appTypes"
import { ICasePathway } from "../../../features/casePathways/state/casePathwayTypes"

export const getCasePathwayById = (ownProps: { casePathwayId: string }) => (state: IAppState): ICasePathway =>
  state.entities.casePathways.byId[ownProps.casePathwayId]
